import type { SxProps, Theme } from '@mui/material'

// Error border styles
export const getErrorBorderStyles = (hasError: boolean): SxProps<Theme> => {
  if (!hasError) return {}

  return {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#F04438',
        borderWidth: '1px',
      },
      '&:hover fieldset': {
        borderColor: '#F04438',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#F04438',
      },
    },
  }
}
